/* eslint-disable no-script-url */
/* eslint-disable jsx-a11y/anchor-is-valid */
import { Box, IconButton } from "@mui/material";
import TableComponent from "../../components/TableComponent";
import { GridColDef } from "@mui/x-data-grid";
import IosSwitchMain from "../../components/iosSwitchMain";
import MenuIcon from '@mui/icons-material/Menu';

const ButterflyEffectTable = () => {

  const label = { inputProps: { 'aria-label': 'Switch demo' } };

  const rows = [
    {
      id: 1,
      category: "Dining",
      title: "The Residence Tunis",
      startDate: "26-Jun-2025",
      endDate: "28-Jun-2025",
    },
    {
      id: 2,
      category: "Dining",
      title: "The Residence Tunis",
      startDate: "26-Jun-2025",
      endDate: "28-Jun-2025",
    },
    {
      id: 3,
      category: "Dining",
      title: "The Residence Tunis",
      startDate: "26-Jun-2025",
      endDate: "28-Jun-2025",
    },
    {
      id: 4,
      category: "Dining",
      title: "The Residence Tunis",
      startDate: "26-Jun-2025",
      endDate: "28-Jun-2025",
    },
    {
      id: 5,
      category: "Dining",
      title: "The Residence Tunis",
      startDate: "26-Jun-2025",
      endDate: "28-Jun-2025",
    },
  ];

  const columns: GridColDef<(typeof rows)[number]>[] = [
    {
      flex: 1,
      minWidth: 150,
      field: "category",
      headerName: "Category",
      editable: false,
      sortable: false,
    },

    {
      flex: 1.2,
      minWidth: 150,
      field: "title",
      headerName: "Title",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 100,
      field: "startDate",
      headerName: "Start Date",
      editable: false,
      sortable: false,
    },
    {
      flex: 1,
      minWidth: 100,
      field: "endDate",
      headerName: "End Date",
      editable: false,
      sortable: false,
    },
    {
      minWidth: 150,
      field: "show",
      headerName: "Show",
      editable: false,
      sortable: false,
      renderCell: () => {
        return (
          <IosSwitchMain />
        )
      }
    },
    {
      minWidth: 150,
      field: "action",
      headerName: "Drag & Drop",
      editable: false,
      sortable: false,
      align: 'center',
      headerAlign: 'center',
      renderCell: () => {
        return (
          <div className="table_actions v2">
            <Box>
              <IconButton className="drag_btn"><MenuIcon /></IconButton>
            </Box>
          </div>
        )
      }
    }
  ];
  let hidden = ["fullName"];

  return (
    <>
      <div className="sorting_table">
        <TableComponent
          columns={columns?.filter((item) => !hidden.includes(item.field))}
          rows={rows}
        />
      </div>
    </>
  );
};

export default ButterflyEffectTable;
